import React from 'react';

export function PageError() {
  return (
    <div>
      <h1 style={{ color: "red" }}>Não encontrado.</h1>
    </div>
  );
}
